<template>
<div class="">
    <!--<ul class="process-steps nav nav-tabs nav-justified text-left">
            <li class="nav-item" v-on:click="setCurrentStep(1)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 1 }" href="#step1" data-toggle="tab">1</a>
                <h5>Booking Details</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(2)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 2 }" href="#step2" data-toggle="tab">2</a>
                <h5>Passenger Details</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(3)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 3 }" href="#step3" data-toggle="tab">3</a>
                <h5>Review</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(4)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 4 }" href="#step4" data-toggle="tab">4</a>
                <h5>Confirmation</h5>
            </li>
        </ul>-->
    <!--<div class="row" v-show="currentStep === 1 && isPriceLoading">
            <div class="col text-center">
                <i class="fa fa-2x fa-spinner fa-spin"></i>
                <h3>One moment please...</h3>
            </div>
        </div>-->

    <div class="row clearfix bookingDetails" v-show="currentStep === 1">
        <div class="col-sm-12 col-md-6">
            <booking-form></booking-form>
        </div>
        <div class="col-sm-12 col-md-6">
            <google-map style="min-height: 300px;" v-show="mapModel.visible" :map-visibility="currentStep === 1" :map-model="mapModel" :map-center="mapModel.mapCenter" id="bookingMap"></google-map>
        </div>
    </div>
    <div class="cbs-main clearfix">
        <div class="row">
            <div class="col-md-9 order-lastt" v-if="currentStep > 1 && currentStep < 5">
                <div class="bookingSelectCar" v-if="currentStep === 2">
                    <h2 class="text-left">{{ $t("forms.services.title") }}</h2>
                    <!--<hr />-->
                    <vehicles-vertical-list></vehicles-vertical-list>
                </div>
                <div class="bookingPassengerDetails" v-if="currentStep === 3">
                    <h2 class="text-left">{{ passengerDetailsTitle }}</h2>
                    <!-- <hr /> -->
                    <passenger-details></passenger-details>
                </div>
                <div class="bookingConfirmBooking" v-if="currentStep === 4">
                    <h2 class="text-left">{{ $t("forms.payment.title") }}</h2>
                    <div class="text-center display-table" v-if="canConfirmByPhone">
                        <h3 class="confirm-by-phone-header" style="">
                            <span class="d-inline-block">{{ $t("forms.payment.confirmByPhoneAt") }}:</span>
                            <a class="confirm-by-phone-number" :href="contactPhoneNumberHref">{{ contactPhoneNumber }}</a>
                        </h3>
                    </div>
                    <div class="text-center" v-if="canConfirmByPhone">
                        <h3 class="mb-0">{{ $t("forms.payment.confirmByPhoneOr") }}</h3>
                    </div>
                    <div class="text-center display-table" v-if="canConfirmByCash" style="margin-top: 15px; margin-bottom: 15px;">
                        <button type="button" class="price-container book-button mt-20" v-on:click="confirmByCash()">
                            <span>
                                <span v-show="isCreateBookingInProgress"><i class="fa fa-spinner fa-spin"></i></span>
                                {{ $t("forms.payment.confirmByCash") }} -
                                {{ selectedCar.totalPrice | round(2, true) }}
                                {{ selectedCar.currency }}
                            </span>
                        </button>
                    </div>
                    <div class="text-center" v-if="canConfirmByCash && (stripeId || paypalId)" style="margin-bottom: 10px;">
                        <h3 class="mb-0">OR</h3>
                    </div>
                    <div class="row mb-3" v-if="stripeId && paypalId">
                        <div class="col-6 text-right">
                            <button class="btn btn-xl mr-2" @click="setConfirmByCard">
                                <img src="https://account.chauffeurbookingsoftware.com/Content/images/components/confirm_by_card.png" style="max-height: 80px;" />
                                <br />
                                Confirm by card
                            </button>
                        </div>

                        <div class="col-6 text-left">
                            <button class="btn btn-xl ml-2" @click="setConfirmByPayPal">
                                <img src="https://account.chauffeurbookingsoftware.com/Content/images/components/confirm_by_paypal.png" style="max-height: 80px;" />
                                <br />
                                Confirm by Paypal
                            </button>
                        </div>
                    </div>
                    <div v-if="stripeId">
                        <div v-show="showConfirmByCard">
                            <span class="mr-3">{{$t("forms.payment.acceptedMethods")}}</span>
                            <img class="mr-2" src="https://account.chauffeurbookingsoftware.com/Content/images/components/visa.png" />
                            <img class="mr-2" src="https://account.chauffeurbookingsoftware.com/Content/images/components/mastercard.png" />
                            <img class="mr-2" src="https://account.chauffeurbookingsoftware.com/Content/images/components/american-express.png" />
                            <img class="mr-2" src="https://account.chauffeurbookingsoftware.com/Content/images/components/paypal.png" />
                        </div>

                        <payment-form v-if="showConfirmByCard"></payment-form>

                        <div class="row text-center" v-if="showConfirmByCard">
                            <div class="col-xs-6 col-sm-4 text-center">
                                <img src="https://account.chauffeurbookingsoftware.com/Content/images/components/mcafeeSecure.png" />
                            </div>
                            <div class="col-xs-6 col-sm-4 text-center">
                                <img src="https://account.chauffeurbookingsoftware.com/Content/images/components/paypalLogo.png" />
                            </div>
                            <div class="col-xs-12 col-sm-4 text-center">
                                <img src="https://account.chauffeurbookingsoftware.com/Content/images/components/verisign.png" />
                            </div>
                        </div>
                    </div>
                    <div v-if="paypalId">
                        <pay-pal-component v-if="showConfirmByPayPal"></pay-pal-component>
                    </div>
                </div>
            </div>
            <div class="col-md-3 order-firstt" v-if="currentStep > 1 && currentStep < 5">
                <booking-summary></booking-summary>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12" v-if="currentStep === 5">
                <booking-confirmation></booking-confirmation>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import HtmlPageService from "./../services/htmlPageService";
import BookingForm from "./../components/booking/bookingFormComponent.vue";
import VehiclesVerticalList from "./../components/booking/vehiclesVerticalListComponent.vue";
import BookingSummary from "./../components/booking/bookingSummaryComponent.vue";
import PassengerDetails from "./../components/booking/passengeDetailsComponent.vue";
import GoogleMap from "./../components/vue-google-map/vue-google-map.vue";
import PaymentForm from "./../components/booking/paymentFormComponent.vue";
import PayPalComponent from "./../components/booking/paypalConfirmationComponent.vue";
import BookingConfirmation from "./../components/booking/bookingConfirmationComponent.vue";
import ApiService from "./../services/apiService.js";
import {
    round
} from "../utils/filters.js";

export default {
    name: "BookingApp",
    components: {
        BookingForm,
        GoogleMap,
        BookingSummary,
        VehiclesVerticalList,
        PassengerDetails,
        PaymentForm,
        BookingConfirmation,
        PayPalComponent,
    },
    filters: {
        round: round
    },
    data: function () {
        return {
            isCreateBookingInProgress: false,
            isConfirmByCardVisible: false,
            isConfirmByPaypalVisible: false,
        };
    },
    mounted: function () {
        //check if we have empty cars and loading prices is true
        //if so -> trigger prices loading
        //         var isPriceLoading = this.$store.state.bookingInfo.general.isPriceLoading;
        var shouldLoadPrices = this.$store.state.booking.bookingInfo.general
            .loadPricesFromServer;
        if (shouldLoadPrices) {
            this.$store.commit("setBookingPricesAreLoading", false);
            this.$store.dispatch("getBookingPrice");
        }
    },
    watch: {
        currentStep: function (oldValue, newValue) {
            console.log("scroll into view", newValue);
            if (newValue == 2) {
                HtmlPageService.scrollElement(".bookingSelectCar", 35);
            } else if (newValue == 3) {
                HtmlPageService.scrollElement(".bookingPassengerDetails", 35);
            } else if (newValue == 4) {
                HtmlPageService.scrollElement(".bookingConfirmBooking", 35);
            }
        },
    },
    methods: {
        setConfirmByCard: function () {
            this.isConfirmByCardVisible = true;
            this.isConfirmByPaypalVisible = false;
        },
        setConfirmByPayPal: function () {
            this.isConfirmByCardVisible = false;
            this.isConfirmByPaypalVisible = true;
        },
        setCurrentStep: function (stepId) {
            this.$store.commit("setCurrentStep", stepId);
        },
        confirmByCash: function () {
            if (this.isCreateBookingInProgress) return;
            this.isCreateBookingInProgress = true;

            //create booking
            var bookingInfo = this.$store.state.booking.bookingInfo;
            var bookingInfoModel = {
                hash: bookingInfo.selectedCar ? bookingInfo.selectedCar.hash : null,
                guid: bookingInfo.general.guid,
                paymentMethod: "Cash",
                passengerDetails: bookingInfo.passengerDetails,
                numberOfCars: bookingInfo.general.numberOfCars,
            };
            ApiService.createBooking(bookingInfoModel)
                .then((response) => {
                    if (!response.data.success) {
                        console.log("CreateBooking error", response.data.errors);
                        this.isCreateBookingInProgress = false;
                        //TODO: show errors at cash payment this.paymentErrors = response.data.errors;
                        return;
                    }

                    this.$store.commit(
                        "booking/setBookingGuid",
                        response.data.result.guid
                    );
                    this.$store.commit(
                        "booking/setBookingHash",
                        response.data.result.hash
                    );
                    this.$store.commit(
                        "booking/setReservationId",
                        response.data.result.reservationId
                    );
                    this.$store.commit(
                        "booking/setReservationGuids",
                        response.data.result.allGuids
                    );
                    this.isCreateBookingInProgress = false;
                    this.$store.commit("booking/setCurrentStep", 5);
                })
                .catch(() => {
                    this.isCreateBookingInProgress = false;
                    //TODO: show errors at cash payment  this.paymentErrors = [this.$t('forms.payment.errorGeneral')];
                });
        },
    },
    computed: {
        passengerDetailsTitle: function () {
            console.log("title");
            var car = this.$store.state.booking.bookingInfo.selectedCar;
            if (!car) return this.$t("forms.passengerDetails.title");
            var isPassengerDetails =
                car.className.indexOf("Personal driver") >= 0 ||
                car.className.indexOf("Airport pick-up") >= 0 ||
                car.className.indexOf("Back home") >= 0;
            if (isPassengerDetails) return this.$t("forms.passengerDetails.title");
            else return this.$t("forms.passengerDetails.contactPersonTitle");
        },
        showConfirmByCard: function () {
            if (!this.stripeId) return false;
            if (!this.paypalId) return true;

            return this.isConfirmByCardVisible;
        },
        showConfirmByPayPal: function () {
            if (!this.paypalId) return false;
            if (!this.stripeId) return true;
            return this.isConfirmByPaypalVisible;
        },
        contactPhoneNumber: function () {
            return this.$store.state.booking.configuration.contactPhone;
        },
        selectedCar: {
            get: function () {
                var car = this.$store.state.booking.bookingInfo.selectedCar;
                if (!car) return {};
                return car;
            },
        },
        canConfirmByCash: function () {
            return this.$store.state.booking.configuration.canConfirmByCash;
        },
        canConfirmByPhone: function () {
            return this.$store.state.booking.configuration.canConfirmByPhone;
        },
        stripeId: function () {
            return this.$store.state.booking.configuration.stripeId;
        },
        paypalId: function () {
            return this.$store.state.booking.configuration.paypalId;
        },
        //isCreateBookingInProgress: function () { return this.$store.state.booking.isCreateBookingInProgress; },
        contactPhoneNumberHref: function () {
            return "tel: +" + this.contactPhoneNumber;
        },
        isPriceLoading: function () {
            return this.$store.state.booking.bookingInfo.general.isPriceLoading;
        },
        currentStep: function () {
            return this.$store.getters["booking/currentStep"];
        },
        distanceInMiles: function () {
            return this.$store.state.booking.bookingInfo.general.distanceInMiles;
        },
        timeInMinutes: function () {
            return this.$store.getters["booking/timeInMinutes"];
        },
        isBookingConfirmed: function () {
            return this.$store.state.booking.bookingInfo.payment.done;
        },
        mapModel: function () {
            //console.log('map changed');
            var mm = this.$store.getters["booking/mapInfo"];
            if (mm.mapCenter == null) console.log("null center");
            return mm;
        },
    },
};
</script>

<style>
.cbs-main .form-control {
    max-width: 100%;
}

.cbs-main .list-unstyled {
    list-style: none;
}

.cbs-car-select-title {
    margin-top: 10px;
    font-size: 18px;
    margin-bottom: 5px;
}

#header.transparent+section.page-header.page-header-xs {
    padding: 75px 0;
    padding-bottom: 20px;
}

.confirm-by-phone-header {
    font-size: 17px;
    margin-top: 0px;
    margin-bottom: 10px;
    line-height: 50px;
}

.confirm-by-phone-number {
    color: #24b47e;
    font-size: 24px;
    line-height: 50px;
    vertical-align: middle;
    padding-left: 10px;
}

.price-container.book-button {
    padding-top: 0px;
    padding-bottom: 0px;
    display: block;
    height: 40px;
    margin: 40px 15px 0;
    background-color: #24b47e;
    border-radius: 4px;
    color: #fff;
    text-transform: uppercase;
    font-weight: 600;
    cursor: pointer;
    width: 300px;
    margin: auto;
    outline: none;
    border-style: none;
}

/*form .row {
    margin-bottom: 20px;
}*/

.scrollable-content {
    overflow-x: hidden;
    overflow-y: -moz-hidden-unscrollable;
}

.scrollable-content::-webkit-scrollbar {
    width: 0px;
}

.scrollable-content::-webkit-scrollbar * {
    background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
    background: rgba(255, 0, 0, 0.1) !important;
}

.picker__holder {
    min-width: 330px;
}

.picker--time.picker--opened .picker__holder {
    width: 141px;
    min-width: 141px;
    max-width: 141px;
    max-height: 205px;
}

.inline-block {
    display: inline-block;
}

/* General style */

.nav-tabs {
    border-color: transparent;
}

.nav-tabs .nav-link.active {
    border-color: transparent;
}

.nav-tabs .nav-link,
.nav-tabs .nav-link:hover {
    border: none;
    cursor: pointer;
}

/* Color styles */
.form-control:focus {
    box-shadow: none !important;
    border-color: #c6c6c6;
}

.nav-tabs>li>a {
    font-weight: 500;
    font-size: 20px;
}

.nav-tabs>li>a.active {
    color: #ab8b64 !important;
}

.btn-primary,
.btn-primary:not(:disabled):not(.disabled):active {
    color: #fff;
    background-color: #ab8b64;
    border-color: #ab8b64;
}

.btn-primary:hover {
    background-color: #ab8b64;
    border-color: #ab8b64;
}

.btn-primary:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus {
    box-shadow: none;
}

a {
    color: #ab8b64;
}

a:hover {
    color: #8f7351;
}

/* General style END */
/*Checkboxes START*/
/* https://bootsnipp.com/snippets/O5oAl  */
/* The radio */
.radio {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default radio button */
.radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkround {
    position: absolute;
    top: 6px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border-color: #ced4da;
    border-style: solid;
    border-width: 2px;
    border-radius: 50%;
}

/* When the radio button is checked, add a blue background */
.radio input:checked~.checkround {
    background-color: #fff;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkround:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio input:checked~.checkround:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.radio .checkround:after {
    left: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #495057;
}

/* The check */
.check {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 12px;
    padding-right: 15px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.check input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 3px;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border-color: #ced4da;
    border-style: solid;
    border-width: 1px;
}

/* When the checkbox is checked, add a blue background */
.check input:checked~.checkmark {
    background-color: #fff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.check input:checked~.checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.check .checkmark:after {
    left: 5px;
    top: -1px;
    width: 6px;
    height: 14px;
    border: solid;
    border-color: #495057;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

/* https://bootsnipp.com/snippets/j6xjx */
/*@keyframes check {
    0% { height: 0; width: 0; }
    25% { height: 0; width: 5px; }
    50% { height: 15px; width: 8px; }
}*/

/*label.cCheckbox {
    margin-top: 2px;
}

label.cCheckbox {
    background-color: #fff;
    display: inline-block;
    height: 20px;
    margin: 0 .25em;
    width: 20px;
    border-radius: 4px;
    border: 1px solid #ccc;
    float: left;
}

    label.cCheckbox span {
        display: block;
        height: 20px;
        position: relative;
        width: 20px;
        padding: 0
    }

        label.cCheckbox span:after {
            -moz-transform: scaleX(-1) rotate(135deg);
            -ms-transform: scaleX(-1) rotate(135deg);
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            -moz-transform-origin: left top;
            -ms-transform-origin: left top;
            -webkit-transform-origin: left top;
            transform-origin: left top;
            border-right: 3px solid #fff;
            border-top: 3px solid #fff;
            content: '';
            display: block;
            height: 15px;
            left: 1px;
            position: absolute;
            top: 10px;
            width: 8px
        }

        / *.checkbox span:hover:after {
            border-color: #999
        }* /

    label.cCheckbox input {
        display: none
    }

        label.cCheckbox input:checked + span:after {
            -webkit-animation: check .8s;
            -moz-animation: check .8s;
            -o-animation: check .8s;
            animation: check .8s;
            border-color: #555
        }

        label.cCheckbox input:checked + .default:after {
            border-color: #444
        }

        label.cCheckbox input:checked + .primary:after {
            border-color: #2196F3
        }

        label.cCheckbox input:checked + .success:after {
            border-color: #8bc34a
        }

        label.cCheckbox input:checked + .info:after {
            border-color: #3de0f5
        }

        label.cCheckbox input:checked + .warning:after {
            border-color: #FFC107
        }

        label.cCheckbox input:checked + .danger:after {
            border-color: #f44336
        }*/

/*Checkboxes END*/
</style>
